import {
  SET_LIVE_LINK_FORM,
  SET_LIVE_LINK_FORM_VALUE,
  SET_SHOW_LIVE_LINK_MODAL,
  SET_SHOW_DELETE_CONFIRMATION,
  SET_LIVE_LINK_SAVING,
} from './action-types';

const initialState = {
  liveLinkForm: null,
  showLiveLinkModal: false,
  showDeleteConfirmation: false,
  liveLinkToDelete: null,
  saving: false,
};

export default function projectLiveLinksUiReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case SET_LIVE_LINK_FORM:
      return {
        ...state,
        liveLinkForm: action.payload,
      };

    case SET_LIVE_LINK_FORM_VALUE:
      return {
        ...state,
        liveLinkForm: {
          ...state.liveLinkForm,
          [action.payload.name]: action.payload.value,
        },
      };

    case SET_SHOW_LIVE_LINK_MODAL:
      return {
        ...state,
        showLiveLinkModal: action.payload,
      };

    case SET_SHOW_DELETE_CONFIRMATION:
      return {
        ...state,
        showDeleteConfirmation: action.payload.show,
        liveLinkToDelete: action.payload.liveLinkId || null,
      };

    case SET_LIVE_LINK_SAVING:
      return {
        ...state,
        saving: action.payload,
      };

    default:
      return state;
  }
}
